import { ExtraWork, ExtraWorkConst } from '../../../const/ShiftConst';

function calcPaymentForTypeOfExtraWork(
  extraWorkList: ExtraWork[],
  typeOfWork: string
): number {
  const extraWorkCompensationList: number[] = extraWorkList
    .filter(obj => obj.typeOfExtraWork === typeOfWork)
    .map(obj => obj.payment);

  const extraWorkCompensation: number = extraWorkCompensationList.length
    ? extraWorkCompensationList.reduce((acc, cur) => acc + cur)
    : 0;
  return extraWorkCompensation;
}

export function CalcExtraByTypeSortCompensation(
  extraWorkList: ExtraWork[],
  typeOfWork: string = ExtraWorkConst.SORT.typeOfExtraWork
): number {
  if (extraWorkList.length) {
    return calcPaymentForTypeOfExtraWork(extraWorkList, typeOfWork);
  } else {
    return 0;
  }
}
